/**
 * Fabpad navigation — desktop dropdowns and mobile menu.
 */
(function () {
  'use strict';

  function initFabpadNav() {
    var nav = document.querySelector('[data-fabpad-nav]');
    if (!nav) return;

    var body = document.body;
    var menu = nav.querySelector('[data-mobile-menu]');
    var menuToggle = nav.querySelector('[data-mobile-menu-toggle]');
    var menuCloseButtons = nav.querySelectorAll('[data-mobile-menu-close]');
    var submenuTriggers = nav.querySelectorAll('[data-mobile-accordion-toggle]');
    var accordionItems = nav.querySelectorAll('[data-mobile-accordion]');
    var directLinks = nav.querySelectorAll('[data-mobile-direct-link]');
    var mobileTabs = nav.querySelectorAll('[data-mobile-tab]');
    var mobileTabPanels = nav.querySelectorAll('[data-mobile-tab-panel]');
    var navItems = nav.querySelectorAll('[data-nav-item]');
    var desktopMq = window.matchMedia('(min-width: 1024px)');

    var hideTimer = null;
    var openItem = null;
    var accordionDuration = 280;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isDesktop() {
      return desktopMq.matches;
    }

    function closePanel(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-nav-dropdown-only]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var panel = item.querySelector('[data-dropdown-panel]');
      if (!panel) return;
      panel.style.opacity = '0';
      window.setTimeout(function () {
        if (!item.classList.contains('is-open')) {
          panel.hidden = true;
        }
      }, 150);
    }

    function closeAllDropdowns() {
      navItems.forEach(closePanel);
      openItem = null;
    }

    function openPanel(item) {
      if (!isDesktop()) return;
      if (openItem && openItem !== item) {
        closePanel(openItem);
      }
      openItem = item;
      item.classList.add('is-open');
      var panel = item.querySelector('[data-dropdown-panel]');
      var trigger = item.querySelector('[data-nav-dropdown-only]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.style.opacity = '1';
      });
    }

    function scheduleClose(item) {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        closePanel(item);
        if (openItem === item) openItem = null;
      }, 100);
    }

    function cancelClose() {
      window.clearTimeout(hideTimer);
    }

    navItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelClose();
        openPanel(item);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose(item);
      });

      var panel = item.querySelector('[data-dropdown-panel]');
      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          scheduleClose(item);
        });
      }
    });

    nav.querySelectorAll('[data-nav-dropdown-only]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        e.preventDefault();
        var item = trigger.closest('[data-nav-item]');
        if (!item) return;
        cancelClose();
        if (openItem === item) {
          closePanel(item);
          openItem = null;
        } else {
          openPanel(item);
        }
      });
    });

    desktopMq.addEventListener('change', function () {
      if (!isDesktop()) closeAllDropdowns();
    });

    function closeAllAccordions(instant) {
      accordionItems.forEach(function (item) {
        closeAccordionItem(item, null, instant);
      });
    }

    function closeAccordionItem(item, callback, instant) {
      if (!item || !item.classList.contains('is-open')) {
        if (callback) callback();
        return;
      }

      var toggle = item.querySelector('[data-mobile-accordion-toggle]');
      var panel = item.querySelector('[data-mobile-accordion-panel]');

      item.classList.remove('is-open');
      item.classList.add('is-closing');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');

      var finish = function () {
        item.classList.remove('is-closing');
        if (callback) callback();
      };

      if (instant || prefersReducedMotion || !panel) {
        window.setTimeout(finish, instant ? 0 : accordionDuration);
        return;
      }

      var done = false;
      var onEnd = function (e) {
        if (e.target !== panel || e.propertyName !== 'max-height') return;
        if (done) return;
        done = true;
        panel.removeEventListener('transitionend', onEnd);
        finish();
      };

      panel.addEventListener('transitionend', onEnd);
      window.setTimeout(function () {
        if (!done) {
          done = true;
          panel.removeEventListener('transitionend', onEnd);
          finish();
        }
      }, accordionDuration + 80);
    }

    function openAccordionItem(item) {
      if (!item) return;

      var toggle = item.querySelector('[data-mobile-accordion-toggle]');
      var panel = item.querySelector('[data-mobile-accordion-panel]');

      item.classList.remove('is-closing');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
      }

      if (prefersReducedMotion) {
        item.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      window.requestAnimationFrame(function () {
        item.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      });
    }

    function activateMobileTab(tabName) {
      mobileTabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-mobile-tab') === tabName;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      mobileTabPanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-mobile-tab-panel') === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (tabName === 'shop') {
        closeAllAccordions(true);
      }
    }

    function resetMobileTabs() {
      activateMobileTab('shop');
    }

    function openMenu() {
      if (!menu) return;
      menu.hidden = false;
      menu.classList.remove('is-closing');
      body.classList.add('menu-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      closeAllAccordions(true);
      resetMobileTabs();
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
      });
    }

    function closeMenu() {
      if (!menu) return;

      menu.classList.add('is-closing');
      closeAllAccordions(true);
      menu.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');

      window.setTimeout(function () {
        body.classList.remove('menu-open');
        menu.classList.remove('is-closing');
        menu.hidden = true;
      }, 300);
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (menu.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    menuCloseButtons.forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });

    mobileTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateMobileTab(tab.getAttribute('data-mobile-tab'));
      });
    });

    submenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var accordion = trigger.closest('[data-mobile-accordion]');
        if (!accordion) return;

        if (accordion.classList.contains('is-open')) {
          closeAccordionItem(accordion);
          return;
        }

        openAccordionItem(accordion);
      });
    });

    directLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    nav.querySelectorAll('.fabpad-mobile-menu__accordion-link, .fabpad-mobile-menu__accordion-shop').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    nav.querySelectorAll('.fabpad-mobile-menu__sub-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    nav.querySelectorAll('.fabpad-mobile-menu__shop-btn, .fabpad-mobile-menu__quiz-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;

      if (body.classList.contains('menu-open')) {
        closeMenu();
      } else if (isDesktop()) {
        closeAllDropdowns();
      }
    });

    if (menu) {
      menu.addEventListener('click', function (e) {
        if (e.target === menu) closeMenu();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFabpadNav);
  } else {
    initFabpadNav();
  }
})();
